
import React from 'react';
import { AdminBackBreadcrumb } from '@/components/dashboard/AdminBackBreadcrumb';

interface IdCardsHeaderProps {
  title?: string;
  isAdmin?: boolean;
}

export const IdCardsHeader: React.FC<IdCardsHeaderProps> = ({ 
  title = "ID Cards",
  isAdmin = false
}) => {
  return (
    <div className="mb-6">
      <AdminBackBreadcrumb />
      <h1 className="text-3xl font-bold mt-4">{title}</h1>
    </div>
  );
};
